import { render } from "./ServiziExtraDataTable.vue?vue&type=template&id=736d4778"
import script from "./ServiziExtraDataTable.vue?vue&type=script&lang=js"
export * from "./ServiziExtraDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__